import { Model } from '@/models/Model';

export class Role extends Model {
  protected $name = 'Role';

  protected $endpoint = '/roles';

  protected $fillable: string[] = [];

  public id?: string;

  public name?: string;
}
